export default {
    SEARCH_FEATURES: 'SEARCH_FEATURES',
    PROFILE_FEATURES: 'PROFILE_FEATURES',
    REPORTING_FEATURES: 'REPORTING_FEATURES'
};
